import React, { useState } from "react";
import { Box, Button, Typography, Snackbar, Alert } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUploadSharp";
import { STATUS } from "../../utils/status";
import axios from "axios";
import { constants } from "../../utils/constants";
import { getCookie } from "../login/cookies";
import getAuthToken from "../../utils/authToken";
import api from "../../utils/api";

export interface UploadSchemaResponse {
    status: string;
    projectId: string;
    message: string;
    data: {
        feilds: string[];
    };
}

interface UploadSchemaProps {
    // onApiResponse?: (responseData: any) => void;
    onApiResponse?: (responseData: UploadSchemaProps) => void;
}

const UploadSchema: React.FC<UploadSchemaProps> = ({onApiResponse}) => {
  const [file, setFile] = useState<File | null>(null);
  const [uploadStatus, setUploadStatus] = useState<string | undefined>(undefined);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error" | "info">("success");

const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  const selectedFile = files[0];
  setFile(selectedFile);

  setUploadStatus(STATUS.PENDING);
  setSnackbarSeverity("info");
  setSnackbarMessage("Uploading schema...");
  setSnackbarOpen(true);

  try {

    const authToken = getCookie("token");

    
    
    if (!authToken) {
      throw new Error("Authentication token not found");
    }

    const formData = new FormData();
    formData.append('schema_file', selectedFile);

 
    const response = await api.post(
      'project/company/project/output-json/generate_from_schema/', 
      formData,
      {
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      }
    );


    if (onApiResponse) {
      onApiResponse(response.data);
    }

    setUploadStatus(STATUS.SUCESS);
    setSnackbarSeverity("success");
    setSnackbarMessage("Schema processed successfully!");
    
  } catch (error: any) {
    setUploadStatus(STATUS.FAILED);
    setSnackbarSeverity("error");
    setSnackbarMessage(
      error.response?.data?.message || 
      error.message || 
      "Failed to upload schema."
    );
  } finally {
    setSnackbarOpen(true);
  }
};

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="20px">
        <Box>
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontSize: "18px",
              fontWeight: 600,
              lineHeight: "24px",
              color: "#10383D",
            }}
          >
            Upload Schema:
          </Typography>
          <Typography
            sx={{
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontWeight: 400,
              color: "#10383D",
              marginTop: "2px", 
            }}
          >
            Only .json, .yaml, .yml are accepted
          </Typography>
        </Box>

        <Button
          component="label"
          variant="contained"
          startIcon={<CloudUploadIcon />}
        >
          Upload Schema
          <input
            type="file"
            accept=".json,.yaml,.yml"
            onChange={handleFileChange}
            hidden
          />
        </Button>
      </Box>

      {uploadStatus === STATUS.SUCESS && file && (
        <Typography sx={{ fontFamily: "Montserrat", fontSize: "14px", color: "#10383D", mt: 1 }}>
          Uploaded file: <strong>{file.name}</strong>
        </Typography>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} variant="filled">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UploadSchema;

